module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "guide"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.guideStep === 1),
      expression: "guideStep === 1"
    }],
    staticClass: "guide",
    attrs: {
      "src": _vm.hqGuideStep1,
      "alt": "报表中心功能说明1"
    },
    on: {
      "click": _vm.handleNext
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.guideStep === 2),
      expression: "guideStep === 2"
    }],
    staticClass: "guide",
    attrs: {
      "src": _vm.hqGuideStep2,
      "alt": "报表中心功能说明2"
    },
    on: {
      "click": _vm.handleKnow
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c12b284"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Guide/Guide.vue
// module id = 754
// module chunks = 8